
import { ArtsApiRemoteService } from '../../Services/api/arts/arts-service'
import { IBoxEntity } from '../../Services/api/boxes/boxes.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class DestroyArtsUseCase
implements IFormUsecase<string, void> {
  constructor (private readonly ArtsApi: ArtsApiRemoteService) {}
    

  public async handle (
    boxId: string
  ): Promise<Result<void>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.ArtsApi.destroy(boxId)

      if (response.isFailure) {
        return response
      }
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
